import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { LicenseService } from 'common/util/module'

export interface MediaFileSort {
  name: string,
  id: string,
  reverse: boolean,
  fileOrdering: string,
  bundleOrdering: string,
  searchOrdering: string,
  newInVersion?: string,
}

export const MediaRootPermissionPermissionFields = [
  'allowRead',
  'allowCreate',
  'allowWriteFs',
  'allowWriteDb',
  'allowOriginalDownload',
  'allowProxyDownload',
  'allowUpload',
  'allowSharing',
  'allowDeleteFs',
  'allowDeleteDb',
]

export const MediaRootPermissionUIVisibilityFields = [
  'showComments',
  'showTags',
  'showLocations',
  'showCustomFields',
  'showRatings',
  'showSubclips',
  'showMarkers',
  'showAiMetadata',
]

export const PlaybackRates = [
  0.5,
  1,
  1.5,
  2,
  5,
  10,
  20,
]

@Injectable({ providedIn: 'root' })
export class MediaConstants {
  mediaFileSorts: MediaFileSort[] = [
    {
      name: 'A→Z',
      id: 'name',
      reverse: false,
      fileOrdering: 'name',
      bundleOrdering: 'name',
      searchOrdering: 'name',
    },
    {
      name: 'Z→A',
      id: 'name',
      reverse: true,
      fileOrdering: '-name',
      bundleOrdering: '-name',
      searchOrdering: '-name',
    },
    {
      name: this.translate.instant('Last created'),
      id: 'created',
      reverse: true,
      fileOrdering: '-modified',
      bundleOrdering: '-asset__created',
      searchOrdering: '-created',
    },
    {
      name: this.translate.instant('First created'),
      id: 'created',
      reverse: false,
      fileOrdering: 'modified',
      bundleOrdering: 'asset__created',
      searchOrdering: 'created',
    },
    {
      name: this.translate.instant('Last modified'),
      id: 'modified',
      reverse: true,
      fileOrdering: '-modified',
      bundleOrdering: '-files__modified',
      searchOrdering: '-modified',
    },
    {
      name: this.translate.instant('First modified'),
      id: 'modified',
      reverse: false,
      fileOrdering: 'modified',
      bundleOrdering: 'files__modified',
      searchOrdering: 'modified',
    },
    {
      name: this.translate.instant('Top rated'),
      id: 'rating',
      reverse: true,
      fileOrdering: '',
      bundleOrdering: '-asset__rating',
      searchOrdering: '-sort_rating',
    },
    {
      name: this.translate.instant('Worst rated'),
      id: 'rating',
      reverse: false,
      fileOrdering: '',
      bundleOrdering: 'asset__rating',
      searchOrdering: 'sort_rating',
    },
    {
      name: this.translate.instant('Timecode ascending'),
      id: 'timecode',
      reverse: false,
      fileOrdering: '',
      bundleOrdering: 'asset__timecode',
      searchOrdering: 'sort_timecode',
      newInVersion: '23.7',
    },
    {
      name: this.translate.instant('Timecode descending'),
      id: 'timecode',
      reverse: true,
      fileOrdering: '',
      bundleOrdering: '-asset__timecode',
      searchOrdering: '-sort_timecode',
      newInVersion: '23.7',
    },
  ]

  constructor (private translate: TranslateService, license: LicenseService) {
    if (license.hasComponent('ltfs')) {
      this.mediaFileSorts.push(
        {
          name: translate.instant('On disk first'),
          id: 'has_files',
          reverse: false,
          fileOrdering: '-present',
          bundleOrdering: '-files__present',
          searchOrdering: '-present',
        },
      )
      this.mediaFileSorts.push(
        {
          name: translate.instant('On tapes first'),
          id: 'has_backups',
          reverse: false,
          fileOrdering: 'present',
          bundleOrdering: '-asset__has_backups',
          searchOrdering: '-on_tape',
        },
      )
    }
  }
}
